import script from "./supplement-name.vue?vue&type=script&setup=true&lang=js"
export * from "./supplement-name.vue?vue&type=script&setup=true&lang=js"

import "./supplement-name.vue?vue&type=style&index=0&id=4f9c6f96&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f9c6f96"]])

export default __exports__